
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.056 15.07L.693 8.708a1 1 0 010-1.414L7.056.929a1 1 0 011.415 1.414L3.814 7H20.6a1 1 0 110 2H3.814l4.657 4.657a1 1 0 11-1.415 1.414z"}})])
          )
        }
      }
    